import { Component } from '@angular/core';

@Component({
  selector: 'app-detail-attendance',
  standalone: true,
  templateUrl: './detail-attendance.component.html',
  styleUrl: './detail-attendance.component.css',
})
export class DetailAttendanceComponent {}
